import { color, OnyxGray } from 'canoe';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { useEventing } from 'commons/eventing';

import { CopyCutAndPaste } from './CopyCutAndPaste';
import { Delete } from './Delete';
import { Separator } from './Separator';

const Container = styled.div`
  width: 240px;
  background-color: ${color(OnyxGray, -1)};
  display: flex;
  flex-direction: column;
  border-radius: 4px;
`;

export const MenuBody = () => {
  const eventing = useEventing();
  useEffect(() => {
    eventing.screen('editor.view.contextMenu');
  }, []);
  return (
    <Container>
      <CopyCutAndPaste />
      <Separator />
      <Delete />
    </Container>
  );
};
